import React from 'react'
import Button from 'ui/buttons/Button'
import { CloseModalOnPipe, Collection, Form, OpenModalOnPipe, Operation } from '@morningtrain/react-resources'
import * as Auth from '@morningtrain/react-auth'
import Modal from 'widgets/modals/Modal'
import { TextArea } from '@morningtrain/react-fields'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import ShiftExchangeRefreshPipes from 'support/actions/shifts/ShiftExchangeRefreshPipes'
import * as Displays from 'support/displays'
import { StaticFilter } from '@morningtrain/react-filters'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Checkbox } from 'support/fields'

export default function ExchangeShift ({ slotId, exchangeId, fullWidth = true }) {
  const modalRef = React.useRef()

  const _resolve = React.useRef()
  const _reject = React.useRef()

  const handleOnSubmit = (data) => {
    if (_resolve.current !== null) {
      _resolve.current(data)
    }
  }

  const handleClose = (err) => {
    if (_reject.current !== null) {
      _reject.current(err)
    }
  }

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      _resolve.current = data => {
        payload.data = data
        resolve(data)
      }
      _reject.current = (err) => {
        reject(err)
      }
    })
  }

  const format = 'YYYY-MM-DD HH:mm:ss'

  return (
    <Auth.CanUseModel permission='api.shifts.exchange.exchange'>
      <Modal ref={modalRef} handleClose={handleClose}>
        <Operation namespace='api' resourceName='shifts.exchange' operationName='exchange'>
          <Form onSubmit={handleOnSubmit} submitTo='exchange'>
            <input type='hidden' name='your_shift_id' value={slotId} />
            <input type='hidden' name='exchange_id' value={exchangeId} />

            <div className='space-y-4'>
              <UI.SecondaryHeading>
                <Translation name='shiftexchange.forms.exchange.title' />
              </UI.SecondaryHeading>
              <UI.Text>
                <Translation name='shiftexchange.forms.exchange.description' />
              </UI.Text>
              <Collection resourceName='shifts.schedule_slot' operationName='index' operationContext={{ group: 'exchangeable_shits', slotId: slotId }}>
                <StaticFilter name='exchangeable_with' value={slotId} />

                <Table operationContext={{ group: 'exchangeable_shits', slotId: slotId }}>
                  <Columns.Checkbox name='my_shift_id' keyAsValue disableHead />
                  <Columns.Column>
                    <Displays.Text name='schedule.department.name' />
                  </Columns.Column>
                  <Columns.Column>
                    <UI.WithSubtitle subtitle={(
                      <UI.Text>
                        <Displays.Time name='start_at' parseFormat={format} /> - <Displays.Time name='end_at' parseFormat={format} />
                      </UI.Text>
                  )}
                    >
                      <UI.Text>
                        <Displays.Date name='start_at' parseFormat={format} dateFormat='dddd - DD.MM.YYYY' />
                      </UI.Text>
                    </UI.WithSubtitle>
                  </Columns.Column>
                </Table>

              </Collection>

              <TextArea name='optional_comment' />
              <UI.ButtonWrap className='my-4 mx-1' leftAlign>
                <Pipeline>
                  <TriggerPipelineOnClick>
                    <UI.Button color='lightgray'>
                      <Translation name='generic.cancel' />
                    </UI.Button>
                  </TriggerPipelineOnClick>
                  <CloseModalOnPipe modalRef={modalRef} />
                </Pipeline>
                <UI.SubmitButton>
                  <Translation name='shiftexchange.actions.exchange_shift' />
                </UI.SubmitButton>
              </UI.ButtonWrap>
            </div>
          </Form>
        </Operation>
      </Modal>

      <Pipeline>
        <TriggerPipelineOnClick>
          <Button className={fullWidth ? 'w-full' : ''}>
            <Translation name='shiftexchange.actions.exchange_shift' />
          </Button>
        </TriggerPipelineOnClick>
        <OpenModalOnPipe modalRef={modalRef} />
        <CallbackOnPipe callback={handleOnPipe} />
        <CloseModalOnPipe modalRef={modalRef} />
        <ShiftExchangeRefreshPipes slotId={slotId} />
      </Pipeline>
    </Auth.CanUseModel>
  )
}
